export default __webpack_public_path__ + "static/media/EimantasJanusis.c2e22741.png";